/**
 * Decide whether an express (e.g. next_day) cart must be re-quoted before the shipping form is
 * submitted, because the address it's about to be submitted with differs from the one the express
 * tier was last quoted against.
 *
 * Why this exists (HL-9096, Bug 2): the byteplant address-suggestion path rewrites zip/city/address
 * via setValue and goes straight to handleShippingSubmit, bypassing updateCartZipcode / the
 * deliveryPriceLoading re-quote chokepoint. Without this guard an express order can be placed on a
 * zip its tier was never validated for — e.g. a next_day order shipped to a zip with no Urbify
 * next_day coverage.
 */
export const shouldRevalidateExpressZip = (
  submittedZip: string | null | undefined,
  quotedZip: string | null | undefined,
  isExpressSelected: boolean,
): boolean => {
  if (!isExpressSelected) return false;
  if (!submittedZip) return false;
  return submittedZip !== quotedZip;
};
